module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAVCAYAAACkCdXRAAAABHNCSVQICAgIfAhkiAAAARxJREFUOI3NlM1tg0AQhb+xuONI8Rk6oAREBbEriEtIKojTQUpICU4HuIO4BM4bCfuOtDkwwHiD5CB88JNWLG9+dmdn34JBDakDr+OFAD+w7ew1pKF9YX+aS4dl6OyNvRlJFumKaw+Zh1QGW+7gLfDPTeJnB7nA9yN8AYiDPfAUrjIR+xVsxIGfmQiAFcjiutv/EQGvjBz2RJwAIg+lQDx7W7QNuM8zs8kOQCGwAc7KVUCho1LurD4Fer96GPnsDFcqV17hdl08qAIUmdMb7iGR9hsbLlYucYMSMrux+21AX6aHo7Q6hUHgFfCp8y2Q6PxdY9ZiS71lA/oy5VJSf94qU0G3uzDm9g04zE3k4QggNSybkfd+CiL4eIDTL9T7b657wL0LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./public/images/ic_mini_calendar.png
// module id = 1279
// module chunks = 0 1